(function(){
  //runs after each cart refresh
  const sideCart = document.querySelector('#side-cart');
  const updateProds = ()=>{
    const component = document.getElementById('cart-recommendations');
    //use window.CartRecommendationsIds globally updated value
    if (component.getAttribute('data-product-ids')!=window.CartRecommendationsIds) {
      component.setAttribute('data-product-ids', window.CartRecommendationsIds);
      component.loadRecommendations()
    }
  }
  if (!sideCart) {
    updateProds();
  }


  if (!window.CartRecommendations) {
    //runs only once
    (function() {
      window.CartRecommendations = document.getElementById('cart-recommendations');
      const component = window.CartRecommendations;
      const sideCart = document.querySelector('#side-cart');
      const panel = document.querySelector('#side-cart .content.recommendations');
      if (panel) {
        component.addEventListener('recommendations:show', ()=>{
          panel.classList.add('open');
        });
        component.addEventListener('recommendations:hide', ()=>{
          panel.classList.remove('open');
        });
      }
      if (sideCart) {
        sideCart.addEventListener('open', updateProds);
      }
    })();
  }
})()
